import { render, staticRenderFns } from "./IconPersonLeft.vue?vue&type=template&id=b503b92e&"
import script from "./IconPersonLeft.vue?vue&type=script&lang=js&"
export * from "./IconPersonLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports